import React, {useEffect, useState} from 'react';
import {Pagination, Select} from "antd";
import {useDispatch, useSelector} from "react-redux";
import {createLocation, deleteLocation, fetchLocations, openModal, setLocation} from "../../redux-store/map";
import {getInstallationsWithoutPag} from "../../redux-store/installations";
import {
    getAllInstallationsWithoutPag,
    getLocationLoader,
    getLocations,
    getLocationsPagination,
    installationsLoad
} from "../../redux-store/selectors";
import LocationModal from "./LocationModal";
import Accordion from 'react-bootstrap/Accordion';
import {Card, Dropdown, useAccordionButton} from "react-bootstrap";
import ellipsis from "../../images/ellipsis-h.png";
import arrowDown from "../../images/arrow-down.png";
import arrowUp from "../../images/arrow-up.png";
import {AiFillEdit} from "react-icons/ai";
import {RiDeleteBin6Line} from "react-icons/ri";
import ConfirmationModal from "./ConfirmationModal";
import DeviceAccordionBody from "./DeviceAccordionBody";
import {fetchDeviceByLocationId} from "../../redux-store/devices";
import AppLoader from "../ApplicationComponent/Loader";
import {useForm} from "react-hook-form";
import pinIcon from "../../images/location.png";
import {formatLatLng, getDeviceLocation} from "../../constants/FunctionJS";
import {setInstallationSelect} from "../../redux-store/globalData";
import {SELECTED_INSTALLATION} from "../../constants/variables";

const {Option} = Select

export const CustomDropDownToggle = React.forwardRef(({children, onClick}, ref) => (
    <button
        className={"btn"}
        ref={ref}
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}
    >
        {children}
    </button>
));

const Devices = () => {

    const dispatch = useDispatch();
    const installations = useSelector(getAllInstallationsWithoutPag);
    const installationLoader = useSelector(installationsLoad);
    const locations = useSelector(getLocations);
    const locationLoader = useSelector(getLocationLoader);
    const {total, pageSize, currentPage} = useSelector(getLocationsPagination);

    const {
        register,
        handleSubmit,
        formState: {},
        setValue,
    } = useForm();

    const [selectData, setSelectData] = useState([]);
    const [selectedValue, setSelectedValue] = useState(null);

    const [activeEventKey, setActiveEventKey] = useState(0);
    const [selectedObject, setSelectedObject] = useState(null);
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);


    const CustomToggle = ({eventKey, location}) => {
        const decoratedOnClick = useAccordionButton(eventKey, () => {
            if (activeEventKey === eventKey)
                setActiveEventKey(0);
            else {
                setActiveEventKey(eventKey);
                dispatch(fetchDeviceByLocationId({installationId: selectedValue.value, locationId: location.id}));
            }
        });
        if (eventKey === activeEventKey)
            return <img src={arrowUp} width={20} height={20} onClick={decoratedOnClick}/>
        return <img src={arrowDown} width={20} height={20} onClick={decoratedOnClick}/>
    }

    const fetchLocationsByInstallationId = async (installationId) => {
        dispatch(fetchLocations({installationId}));
    }

    useEffect(() => {
        dispatch(getInstallationsWithoutPag());
    }, []);

    useEffect(() => {
        const selectedData = installations.map((item, counter) => {
            const selectItem = localStorage.getItem(SELECTED_INSTALLATION);
            if (counter === 0) {
                if (selectItem !== null)
                    handleInstallationSelectChange(JSON.parse(selectItem))
                else
                    handleInstallationSelectChange({label: item.name, value: item.id})
            }
            return (<Option value={item.id}>{item.name}</Option>)
        });
        setSelectData(selectedData)
    }, [installations]);

    const handleInstallationSelectChange = selectedValue => {
        localStorage.setItem(SELECTED_INSTALLATION,JSON.stringify(selectedValue));
        setSelectedValue(selectedValue);
        dispatch(setInstallationSelect({
            label: selectedValue.label, value: selectedValue.value
        }))
        fetchLocationsByInstallationId(selectedValue.value);
    }

    const handleLocationEdit = (location) => {
        dispatch(openModal());
        dispatch(setLocation(location));
    }
    const handleLocationDelete = (location) => {
        setShowConfirmationModal(true);
        setSelectedObject(location);
    }
    const onDeleteSubmit = () => {
        setShowConfirmationModal(false);
        dispatch(deleteLocation({installationId: selectedValue.value, locationId: selectedObject.id}));
    }
    const onConfirmationModalClose = () => {
        setShowConfirmationModal(false);
    }
    const onLocationsSubmit = data => {
        dispatch(createLocation({
            installationId: selectedValue.value,
            data
        }))
    }
    const handleLocationRequest = async () => {
        try {
            const location = await getDeviceLocation();
            const {latitude, longitude} = location;
            setValue("latitude", formatLatLng(latitude));
            setValue("longitude", formatLatLng(longitude));
        } catch (err) {

        }
    }

    const getLocationCard = (location) => {
        return (
            <Card>
                <Card.Header>
                    <div className={"d-flex align-items-center"}>
                        <CustomToggle eventKey={location.id} location={location}>Click me!</CustomToggle>
                        <div className={"d-flex justify-content-between w-100 align-items-baseline"}>
                            <span className={"device-accordion-title"}>{location.name}</span>
                            <div className={"d-flex align-items-center"}>
                                <span
                                    className={"device-accordion-lat-lng"}><span>Dužina</span> {formatLatLng(location.longitude)}</span>
                                <span
                                    className={"device-accordion-lat-lng"}><span>Širina</span> {formatLatLng(location.latitude)}</span>
                                <div>
                                    <Dropdown align="end">
                                        <Dropdown.Toggle as={CustomDropDownToggle} id="dropdown-custom-components">
                                            <img src={ellipsis} width={5} height={15} className={"ms-2"}/>
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            <Dropdown.Item eventKey="1" className={"update-button-card"}
                                                           onClick={handleLocationEdit.bind(this, location)}>
                                                <AiFillEdit/> Izmjeni
                                            </Dropdown.Item>
                                            <Dropdown.Item eventKey="2" className={"delete-button-card"}
                                                           onClick={handleLocationDelete.bind(this, location)}>
                                                <RiDeleteBin6Line/> Obriši
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <span className={"ms-4 text-muted"}>{location.description}</span>
                    </div>
                </Card.Header>
                <Accordion.Collapse eventKey={location.id}>
                    <Card.Body>
                        <DeviceAccordionBody locationId={location.id} activeKey={activeEventKey}/>
                    </Card.Body>

                </Accordion.Collapse>
            </Card>);
    }
    const getLocationCreateCard = () => {
        return (
            <Card>
                <Card.Header className={"d-flex justify-content-between align-items-center add-new-location"}>
                    Kreiraj lokaciju
                    <input className={"btn btn-modal-confirm"} type={"submit"} value={"Kreiraj"}
                           onClick={handleSubmit(onLocationsSubmit)}/>
                </Card.Header>
                <Card.Body>
                    <form onSubmit={handleSubmit(onLocationsSubmit)}>
                        <div className={"row align-items-end"}>
                            <div className={"col-12 col-md-6 col-lg-4 col-xl-4 pb-2"}>
                                <label className="mb-2 form-label" htmlFor="name">Ime lokacije</label>
                                <input type="text" className="form-control" name="name"
                                       required autoFocus {...register("name", {required: true})} />
                            </div>
                            <div className={"col-12 col-md-6 col-lg-3 col-xl-3 pb-2"}>
                                <label className="form-label" htmlFor="description">Dužina</label>
                                <input type="text" className="form-control" name="longitude"
                                       required autoFocus {...register("longitude", {required: true})}/>
                            </div>
                            <div className={"col-12 col-md-6 col-lg-3 col-xl-3 pb-2"}>
                                <label className="form-label" htmlFor="description">Širina</label>
                                <input type="text" className="form-control" name="latitude"
                                       required autoFocus {...register("latitude", {required: true})}/>
                            </div>
                            <div className={"col-12 col-md-6 col-lg-2 col-xl-2 pb-2"}>
                                <button className={"btn btn-longlat"} type={"button"} onClick={handleLocationRequest}>
                                    <img src={pinIcon}/>
                                </button>
                            </div>
                        </div>
                    </form>
                </Card.Body>
            </Card>
        )
    }
    return (
        <>
            <LocationModal installationId={selectedValue?.value}/>
            <ConfirmationModal show={showConfirmationModal} onSubmit={onDeleteSubmit}
                               onClose={onConfirmationModalClose}
                               text={"Da li ste sigurni da želite obrisati ovu lokaciju?"}/>
            <div className={"container-fluid pt-3 p-side"}>
                <div className={"row pt-3 pb-3 bottom-line"}>
                    <div className={"col-12 col-md-6 col-lg-6 col-xl-6"}>
                        <div className="d-flex align-items-center installation-select">
                            <label className="home-page-label">Uređaji</label>
                            <div className="col-7 col-md-7 col-lg-5 col-xl-4 ant-select-installations">
                                <Select labelInValue style={{width: "200px"}} loading={installationLoader}
                                        disabled={installationLoader}
                                        onChange={handleInstallationSelectChange} value={selectedValue}>
                                    {selectData}
                                </Select>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"row pt-3 d-flex justify-content-center"}>
                    <div className={"col-12 col-md-10 col-lg-8 col-xl-8"}>
                        {getLocationCreateCard()}
                    </div>
                </div>
                {locationLoader ? <AppLoader/> : <div className={"row pt-3 d-flex justify-content-center"}>
                    <div className={"col-12 col-md-10 col-lg-8 col-xl-8"}>
                        <div className={"device-body-header"}>
                            <h5 className={"font-bold"}>{selectedValue?.label} lokacije:</h5>
                            <Pagination defaultCurrent={1}
                                        current={currentPage + 1}
                                        total={total}
                                        showSizeChanger={false}
                                        onChange={(newPage, newPageSize) => {
                                            dispatch(fetchLocations({
                                                installationId: selectedValue.value,
                                                page: newPage - 1,
                                                pageSize
                                            }));
                                        }}
                                        defaultPageSize={pageSize}/>

                        </div>
                        <div className={"device-body-cards"}>
                            <Accordion defaultActiveKey="0">
                                {locations.map((item, counter) => getLocationCard(item))}
                            </Accordion>
                        </div>
                    </div>
                </div>}

            </div>
        </>

    );
};

export default Devices;
